module.exports = __webpack_public_path__ + "img/marker_doanhnghiep3.db85ce62.png";